export default "__VITE_ASSET__11e2b466__"